import { render, staticRenderFns } from "./syslist.vue?vue&type=template&id=2c707b40&scoped=true"
import script from "./syslist.vue?vue&type=script&lang=js"
export * from "./syslist.vue?vue&type=script&lang=js"
import style0 from "./syslist.vue?vue&type=style&index=0&id=2c707b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c707b40",
  null
  
)

export default component.exports